import React from 'react';
import { Divider } from '@mantine/core';
import PropTypes from 'prop-types';
import WsAccountOrderSummaryProduct from './WsAccountOrderSummaryProduct';
import AppFlexbox from '../../../../../common/AppFlexbox';
import { getBundleTaxItems } from '../../../../../../helpers/storeHelper';

const WsAccountOrderSummaryProductsGrouped = ({
  ecomOrderPackage,
  ecomOrderPackageLineItem,
  products,
  baseStoreUrl,
  mediaQueries,
  onNavigate,
  onViewTracking,
  loading,
  isCancelledList,
  filterListByCancelled,
  hidePrice,
  padding
}) =>
  !loading ? (
    !ecomOrderPackage ? (
      products
        .filter((p) =>
          !filterListByCancelled
            ? true
            : isCancelledList
            ? p.cancelledCount > 0
            : p.quantity - p.cancelledCount > 0
        )
        .map((p, index) => (
          <React.Fragment key={p.key}>
            {index > 0 && <Divider />}
            <AppFlexbox
              style={{ padding: padding !== undefined ? padding : 16 }}
            >
              <WsAccountOrderSummaryProduct
                addOns={p.addOns}
                baseStoreUrl={baseStoreUrl}
                currency={p.currency}
                hidePrice={hidePrice}
                isCancelledList={isCancelledList}
                mediaQueries={mediaQueries}
                onNavigate={onNavigate}
                previewImage={p.previewImage}
                productName={p.name}
                tax={p.tax}
                taxRate={p.taxRate}
                unitPrice={p.unitCost}
                unitTax={p.unitTax}
                urlHandle={p.productUrlHandle}
                {...(isCancelledList
                  ? {
                      cancelledCount: p.cancelledCount,
                      count: p.cancelledCount,
                      shippingCount: 0
                    }
                  : {
                      cancelledCount: 0,
                      count: p.quantity - p.cancelledCount,
                      onViewTracking: () => onViewTracking(p),
                      shippingCount: p.shippedCount
                    })}
              />
            </AppFlexbox>
          </React.Fragment>
        ))
    ) : (
      <AppFlexbox style={{ padding: padding !== undefined ? padding : 16 }}>
        <WsAccountOrderSummaryProduct
          addOns={ecomOrderPackageLineItem.addOns}
          baseStoreUrl={baseStoreUrl}
          bundleProducts={products.filter((p) =>
            !filterListByCancelled
              ? true
              : isCancelledList
              ? p.cancelledCount > 0
              : p.quantity - p.cancelledCount > 0
          )}
          cancelledCount={0}
          count={isCancelledList ? 1 : ecomOrderPackageLineItem.quantity}
          currency={ecomOrderPackageLineItem.currency}
          hidePrice={hidePrice}
          isCancelledList={isCancelledList}
          mediaQueries={mediaQueries}
          onNavigate={onNavigate}
          onViewTracking={(p) => onViewTracking(p)}
          previewImage={ecomOrderPackageLineItem.previewImage}
          productName={ecomOrderPackageLineItem.productName}
          tax={getBundleTaxItems(ecomOrderPackageLineItem)}
          unitPrice={ecomOrderPackageLineItem.totalInCents}
          unitTax={ecomOrderPackageLineItem.taxInCents}
          urlHandle={ecomOrderPackageLineItem.urlHandle}
        />
      </AppFlexbox>
    )
  ) : (
    <WsAccountOrderSummaryProduct loading />
  );

WsAccountOrderSummaryProductsGrouped.propTypes = {
  baseStoreUrl: PropTypes.string,
  ecomOrderPackage: PropTypes.object,
  ecomOrderPackageLineItem: PropTypes.object,
  filterListByCancelled: PropTypes.bool,
  hidePrice: PropTypes.bool,
  isCancelledList: PropTypes.bool,
  loading: PropTypes.bool,
  mediaQueries: PropTypes.object,
  onNavigate: PropTypes.func,
  onViewTracking: PropTypes.func,
  padding: PropTypes.number,
  products: PropTypes.array
};

export default WsAccountOrderSummaryProductsGrouped;
